import React, { useEffect, useState } from "react";
import API from "../services/api";

const WhatsappPanel = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedUsers, setSelectedUsers] = useState([]);
const [toast, setToast] = useState({
  show: false,
  message: "",
  type: "success"
});

  const getUsers = async () => {
    try {
      const res = await API.get("/whatsapp/get-whatsapp-users.php");
      setUsers(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const toggleUserSelection = (id) => {

    if (selectedUsers.includes(id)) {
  
      setSelectedUsers(
        selectedUsers.filter(userId => userId !== id)
      );
  
    } else {
  
      setSelectedUsers([...selectedUsers, id]);
  
    }
  
  };

  const sendMessage = async (id, name) => {
    try {
      const formData = new FormData();
      formData.append("user_id", id);
      formData.append("message", message);
  
      const res = await API.post("/whatsapp/send-whatsapp-message.php", formData);
  
      alert(`Message sent successfully to ${name}`);
      getUsers(); // Refresh status
    } catch (error) {
      console.log(error);
      alert("Failed to send message");
    }
  };

  const sendBulkMessages = async () => {

    if (selectedUsers.length === 0) {
  
      setToast({
        show: true,
        message: "Please select users before sending messages",
        type: "danger"
      });
  
      setTimeout(() => {
        setToast({
          show: false,
          message: "",
          type: "danger"
        });
      }, 3000);
  
      return;
    }
  
    try {
  
      for (let i = 0; i < selectedUsers.length; i++) {
  
        const userId = selectedUsers[i];
  
        const formData = new FormData();
  
        formData.append("user_id", userId);
        formData.append("message", message);
  
        await API.post(
          "/whatsapp/send-whatsapp-message.php",
          formData
        );
  
        // 🔥 DELAY 1.5 sec between messages
        await new Promise(resolve =>
          setTimeout(resolve, 1500)
        );
  
      }
  
      setToast({
        show: true,
        message: `Messages sent to ${selectedUsers.length} users`,
        type: "success"
      });
  
      setSelectedUsers([]);
  
      getUsers();
  
    } catch (error) {
  
      console.log(error);
  
      setToast({
        show: true,
        message: "Bulk sending failed",
        type: "danger"
      });
  
    }
  
    setTimeout(() => {
      setToast({
        show: false,
        message: "",
        type: "success"
      });
    }, 3000);
  
  };

  // Filter users based on search
  const filteredUsers = users.filter(user =>
    user.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.phone_number?.includes(searchTerm)
  );

  return (
    <div className="container-fluid h-100 p-3" style={{ backgroundColor: "#f0f2f5" }}>
      <div className="card shadow-lg h-100" style={{ borderRadius: "12px", overflow: "hidden" }}>
        
        {/* Header */}
        <div className="card-header bg-success text-white py-3">
        <div className="d-flex align-items-center">
            <div className="bg-white text-success rounded-circle d-flex align-items-center justify-content-center me-3" 
                 style={{ width: "40px", height: "40px", fontSize: "20px" }}>
<img src="https://img.icons8.com/fluency/48/000000/whatsapp.png" alt="WhatsApp" />
            </div>
            <div>
              <h4 className="mb-0">WhatsApp Broadcast Panel</h4>
              <small>Send messages to multiple users</small>
            </div>
          </div>
        </div>

        <div className="row h-100 g-0">

          {/* Left Sidebar - Users List */}
          <div className="col-lg-5 col-xl-4 border-end bg-white" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
            <div className="p-3 border-bottom">
              <div className="input-group">
                <span className="input-group-text bg-light">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by name or phone..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="list-group list-group-flush">
              {filteredUsers.map((user) => (
                <div key={user.id} className="list-group-item list-group-item-action p-3 hover-bg-light">
                  <div className="d-flex align-items-center">
                  <input
  type="checkbox"
  className="form-check-input me-3"
  checked={selectedUsers.includes(user.id)}
  onChange={() => toggleUserSelection(user.id)}
/>
                    <div className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-3"
                         style={{ width: "50px", height: "50px", fontSize: "18px" }}>
                      {user.full_name?.charAt(0).toUpperCase()}
                    </div>

                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-1">{user.full_name}</h6>
                        <small className="text-muted">{user.phone_number}</small>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">{user.email}</small>
                        <span className={`badge ${user.message_status === 'Sent' ? 'bg-success' : 'bg-secondary'}`}>
                          {user.message_status || "Not Sent"}
                        </span>
                      </div>
                      {user.message_datetime && (
                        <small className="text-muted">Sent: {user.message_datetime}</small>
                      )}
                    </div>

                    <button
                      className="btn btn-success btn-sm ms-3 px-4"
                      onClick={() => sendMessage(user.id, user.full_name)}
                      // disabled={!message.trim()}
                      // disabled={false}
                    >
                      Send
                    </button>
                  </div>
                </div>
              ))}

              {filteredUsers.length === 0 && (
                <div className="text-center text-muted py-5">
                  No users found
                </div>
              )}
            </div>
          </div>

          {/* Right Side - Message Composer */}
          <div className="col-lg-7 col-xl-8 d-flex flex-column bg-light" >
            
            {/* Chat Header */}
            <div className="bg-white border-bottom p-3">
              <h5 className="mb-1">Message Composer</h5>
              <small className="text-muted">Type your message once and send to any user from the list</small>
            </div>

            {/* Message Preview Area */}
            <div className="flex-grow-1 p-4 overflow-auto" style={{ maxHeight: "calc(100vh - 280px)" }}>
              {message ? (
                <div className="bg-success text-white p-3 rounded-3 shadow-sm ms-auto" 
                     style={{ maxWidth: "75%", borderBottomRightRadius: "4px" }}>
                  {message}
                </div>
              ) : (
                <div className="h-100 d-flex align-items-center justify-content-center text-muted">
                  <div className="text-center">
                    <i className="bi bi-chat-text display-4 mb-3"></i>
                    <p>Enter your message below</p>
                  </div>
                </div>
              )}
            </div>

            {/* Message Input Area (WhatsApp Style) */}
            <div className="bg-white border-top p-3">
              <textarea
                className="form-control mb-3"
                rows="4"
                placeholder="Type your message here..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{ resize: "none", borderRadius: "12px" }}
              />

              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">
                  {message.length}/1000 characters
                </small>
                <button
                  className="btn btn-success px-4"
                  onClick={sendBulkMessages}
                  // disabled={!message.trim()}
                >
                  <i className="bi bi-send me-2"></i>
                  Send to Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
  toast.show && (
    <div
      className={`toast show position-fixed bottom-0 end-0 m-4 text-white bg-${toast.type}`}
      style={{
        zIndex: 9999,
        minWidth: "300px",
        borderRadius: "12px"
      }}
    >
      <div className="toast-body d-flex justify-content-between align-items-center">
        <span>{toast.message}</span>

        <button
          className="btn-close btn-close-white"
          onClick={() =>
            setToast({
              show: false,
              message: "",
              type: "success"
            })
          }
        />
      </div>
    </div>
  )
}
    </div>
  );
};

export default WhatsappPanel;